export const ConfigPermissionOption = {
  actionCommentReply: "actionCommentReply", //quyen tra loi binh luan
  actionIgnore: "actionIgnore", // quyen bo qua bai viet hoac comment
  actionFollowPost: "actionFollowPost", //quyen theo doi bai viet hoac comment
  actionMessage: "actionMessage", //quyen nhan tin
  actionDeleteComment: "actionDeleteComment", //quyen xoa binh luan
  actionEmotionalEvaluation: "actionEmotionalEvaluation", //quyen danh gia cam xuc
  actionEditComment: "actionEditComment", //quyen sửa bình luận
  actionLikeDislike: "actionLikeDislike", //quyen like, disLike bình luận
  actionRefeshPost: "actionRefeshPost", //quyen refesh bài viết
  actionScanAccountManagement: "actionScanAccountManagement", //quyen quản lý tài khoản quét
  actionSeedingAccountManager: "actionSeedingAccountManager", //quyen quản lý tài khoản seeding
  actionViewSeedingAccount: "actionViewSeedingAccount", //quyen xem tài khoản seeding
  actionVPSHostingManagement: "actionVPSHostingManagement", //quyen quản lý tài khoản VPShotsting
  actionPriorityListManagement: "actionPriorityListManagement", //quyen quản lý tài khoản ưu tiên
  actionTokenManagement: "actionTokenManagement", //quyen quản lý tokens
  actionGeneralReport: "actionGeneralReport", //quyền xem báo cáo tổng quan
  actionResponseRate: "actionResponseRate", //Quyền xem báo cáo tỷ lệ đáp ứng MXH
  actionSeedingReport: "actionSeedingReport", //Quyền xem báo cáo phụ lục tương tác
  actionGeneralTopicReport: "actionGeneralTopicReport", //Quyền xem báo cáo tổng quan theo chủ đề
  actionProcessByProject: "actionProcessByProject", //Quyền xem báo cáo xử lý công việc theo chủ đề
  actionViewDashboard1: "actionViewDashboard1", //Quyền xem dashboard 1,
  actionViewDashboardDetail: "actionViewDashboardDetail", //Quyền xem dashboard 1
  actionViewDashboard2: "actionViewDashboard2", //Quyền xem dashboard 2
  actionViewDashboard3: "actionViewDashboard3", //Quyền xem dashboard 3
  actionViewDashboard4: "actionViewDashboard4", //Quyền xem dashboard 4
  actionViewDashboard5: "actionViewDashboard5", //Quyền xem dashboard 5 nội dung nổi bật
  actionViewDashboard6: "actionViewDashboard6", //Quyền xem dashboard 6 pain point
  actionConfigNewsAnalytic: "actionConfigNewsAnalytic", //Quyền cấu hình phân tích bài báo
  actionCommentTmpManagement: "actionCommentTmpManagement", //Quyền quan ly binh luan mau
  actionPostManagement: "actionPostManagement", //Quyền quan ly bai viet
  actionNewsReport: "actionNewsReport", // Báo cáo tổng hợp tin bài
  actionCrawlerReport: "actionCrawlerReport", // Báo cáo trình thu thập thông tin
  actionPostTemplateManagement: "actionPostTemplateManagement", //Quyềnquản lý bài viết mẫu
  actionQuickresearchProject: "actionQuickresearchProject", //Quyền nghiên cứu nhanh chủ đề
  actionSentimentReport: "actionSentimentReport", // Báo cáo cảm xúc theo chủ đề
  actionSupervisionReport: "actionSupervisionReport", // Báo cáo giám sát
  actionDiscussSentimentReport: "actionDiscussSentimentReport", // Báo cáo cảm xúc theo chủ đề và chủ đề thảo luận
  actionProvinceSentimentReport: "actionProvinceSentimentReport", // Báo cáo top tỉnh thành
  actionHearingMonitorReport: "actionHearingMonitorReport", // báo cáo giám sát hearing
  actionFollowProcessReport: "actionFollowProcessReport", // báo cáo theo dõi xử lý
  actionKriReport: "actionKriReport", // báo cáo Kri
  actionKriMonitorReport: "actionKriMonitorReport", // báo cáo Kri
  actionBacklogLink: "actionBacklogLink", // báo cáo link tồn
  actionProjectManagement: "actionProjectManagement", // quyen quan ly chu de
  actionProjectRoleManagement: "actionProjectRoleManagement", //quyen phan quyen chu de
  actionDiscussionProject: "actionDiscussionProject", //quyen quan ly chu de thao luan
  actionLogManagement: "actionLogManagement", //quyen quan ly logs
  actionPostNegative: "actionPostNegative", //quyen xem thong ke cac bai viet tieu cuc chua duoc xu ly
  actionReScan: "actionReScan", // quyền quản lý cấu hình quét lại
  actionAddPosts: "actionAddPosts", // quyền thêm bài viết thủ công
  actionBrands: "actionBrands", // quyền quản lý Báo cáo chất lượng tổng thể thương hiệu
  actionReportManager: "actionReportManager", // quyền quản lý xuất báo cáo
  actionSeedingBotReport: "actionSeedingBotReport", // quyền quản lý báo cáo pha loãng bài viết
  actionArticleReport: "actionArticleReport", // báo cáo danh sách bài báo
  actionTopFacebookReport: "actionTopFacebookReport", // baos caos top thao luan facebook
  actionWeeklyReport: "actionWeeklyReport", // Bao cao tuong tac hang tuan
  actionNegativeReport: "actionNegativeReport", // Bao cao tuong tac hang tuan
  // báo cáo mytv
  actionDiscussionTotalReport: "actionDiscussionTotalReport", // báo cáo tổng lượng thảo luận
  actionDiscussionTvSocial: "actionDiscussionTvSocial", // Báo cáo thảo luận truyền hình
  actionDiscussionTrend: "actionDiscussionTrend", //Báo cáo tổng thảo luận và xu hướng thảo luận
  actionSentimentIndex: "actionSentimentIndex", // báo cáo chỉ số cảm xúc
  actionTopContentDiscuss: "actionTopContentDiscuss", // Báo cáo Top nội dung thảo luận nhiều nhất
  actionBrandDataSource: "actionBrandDataSource", //Báo cáo thống kê nguồn dữ liệu
  // báo cáo tổng quan thương hiệu
  actionTableContent: "actionTableContent", // quản lý mục lục
  actionBrandReport: "actionBrandReport", // báo cáo tổng quan
  actionOutstandingStatistics: "actionOutstandingStatistics", // báo cáo thống kê nổi bật thương hiệu
  actionChannelDiscussion: "actionChannelDiscussion", //báo cáo kênh thảo luận
  actionPageAnalytic: "actionPageAnalytic", //báo cáo hiệu quả bài đăng trên Fanpage
  actionUserOverview: "actionUserOverview", //báo cáo chân dung người thảo luận
  actionCompareSource: "actionCompareSource", //Báo cáo so sánh nguồn bài đăng

  actionDiscussDevelopmentBrands: "actionDiscussDevelopmentBrands", //Báo cáo Diễn biến thảo luận về các thương hiệu
  actionDiscussionDevelopment: "actionDiscussionDevelopment", //Báo cáo Diễn biến thảo luận
  actionSentimentBrandReport: "actionSentimentBrandReport", //Báo cáo So sánh sắc thái thảo luận các thương hiệu
  actionSentimentDiscussReport: "actionSentimentDiscussReport", //Báo cáo sắc thái thảo luận
  actionBrandComparison: "actionBrandComparison", // báo cáo so sánh thương hiệu
  actionDetailReport: "actionDetailReport", //Báo cáo chi tiết nội dung theo chủ đề
  actionFeaturedContent: "actionFeaturedContent", //Báo cáo nội dung thảo luận nổi bật về thương hiệu
  actionHealthBrand: "actionHealthBrand", //Báo cáo so sánh sức khỏe thương hiệu
  actionDiscussionMarketShare: "actionDiscussionMarketShare", // Báo cáo thị phần các thương hiệu
  actionComparePageAnalytic: "actionComparePageAnalytic", // Báo cáo so sánh hình thức bài đăng trên Fanpage

  actionAutoSeeding: "actionAutoSeeding", // auto seeding
  actionAutoLikePage: "actionAutoLikePage",
  actionAutoFollowUser: "actionAutoFollowUser",
  actionAutoLikePost: "actionAutoLikePost",
  actionAutoLikeComment: "actionAutoLikeComment",
  actionAutoShare: "actionAutoShare",
  actionAutoComment: "actionAutoComment",
  actionAutoPost: "actionAutoPost",
  actionAutoJoinGroup: "actionAutoJoinGroup",
  actionAutoDynamicScript: "actionAutoDynamicScript",

  showEditTime: "showEditTime", // auto seeding edit time
  actionPTTTReport: "actionPTTTReport",
  actionGroupDiscussion: "actionGroupDiscussion",
  actionE14Report: "actionE14Report",
  actionUserManagement: "actionUserManagement",

  actionRequestProcessing: "actionRequestProcessing",
  actionConsultingHistory: "actionConsultingHistory",
  actionExploitationReport: "actionExploitationReport",
  actionReportWorkPerformance: "actionReportWorkPerformance",
  actionCreatedOrder: "actionCreatedOrder",
  actionUserTimeReport: "actionUserTimeReport",

  // Quyền cấu hình quét báo
  actionCreateNewsConfig: "actionCreateNewsConfig",
  actionEditNewsConfig: "actionEditNewsConfig",
  actionDeleteNewsConfig: "actionDeleteNewsConfig",

  actionBrandManage: "actionBrandManage", //Quản lý thương hiệu
  actionRoleBrand: "actionRoleBrand", //Phân quyền thương hiệu
  actionDepartment: "actionDepartment", //Quản lý phòng ban
  actionDeleteTopic: "actionDeleteTopic", //Quyền khoá/mở khoá và xoá chủ đề
  actionSeedingTopic: "actionSeedingTopic", //Quyền chỉnh sửa cấu hình auto seeding chủ đề
  actionSettingTopic: "actionSettingTopic", //Quyền chỉnh sửa cấu hình chủ đề,
  actionNewsSource: "actionNewsSource",
};



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_helpers/config-permission-option.ts